
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class TreeMakingIssueDialog extends Serenity.EntityDialog<TreeMakingIssueRow, any> {
        protected getFormKey() { return TreeMakingIssueForm.formKey; }
        protected getIdProperty() { return TreeMakingIssueRow.idProperty; }
        protected getLocalTextPrefix() { return TreeMakingIssueRow.localTextPrefix; }
        protected getNameProperty() { return TreeMakingIssueRow.nameProperty; }
        protected getService() { return TreeMakingIssueService.baseUrl; }
        protected getDeletePermission() { return TreeMakingIssueRow.deletePermission; }
        protected getInsertPermission() { return TreeMakingIssueRow.insertPermission; }
        protected getUpdatePermission() { return TreeMakingIssueRow.updatePermission; }

        protected form = new TreeMakingIssueForm(this.idPrefix);

    }
}